import "./App.css";
import { Navbar } from "./components/navbar/Navbar";
import { Slider } from "./components/slider/Slider";
import { Services } from "./components/services/Services";
import { About } from "./components/about/About";
import { Form } from "./components/form/Form";
import { Footer } from "./components/footer/Footer";
function App() {
  return (
    <>
      <Navbar />
      <Slider />
      <Services />
      <About />
      <Form />
      <Footer />
    </>
  );
}

export default App;
